// Phase 0 placeholder — operator shell with role-scoped tabs comes in Phase 2.
const OperatorShell = () => {
  return (
    <main className="min-h-dvh flex flex-col items-center justify-center px-4 text-center">
      <p className="up text-ink-500">POLF · Admin · Operatør</p>
      <h1 className="font-display font-extrabold text-3xl tracking-tight text-green-900 mt-2">
        Velkommen, operatør
      </h1>
      <p className="font-sans text-base text-ink-700 mt-3 max-w-md">
        Operatør-skall under bygging — Fase 0 OK.
      </p>
    </main>
  )
}

export default OperatorShell
